import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {I18n} from '@aws-amplify/core';

import {Stack, Title} from '@mantine/core';

import {useParams} from 'react-router-dom';

import RecordForm from '../forms/RecordForm';

import {ActivityIndicator} from 'components/ActivityIndicator';

import {signinOptionsSelector} from '../selectors';

import {fetchSigninOptions, updateSigninOption,} from '../reducers/recordsSlice';

export const EditPage = () => {
    const dispatch = useDispatch();

    const signinOptions = useSelector((state) => signinOptionsSelector(state));

    const { id: signinOptionId } = useParams();

    useEffect(() => {
        dispatch(fetchSigninOptions());
    }, [dispatch]);

    let selectedSigninOption = signinOptions.find(
        (item) => item.id === signinOptionId
    );

    const saveRecord = (values) => {
        dispatch(updateSigninOption({ id: signinOptionId, record: values }));
    };

    if (!selectedSigninOption) {
        return (
            <ActivityIndicator label="Loading Sign-In Options...Please wait!" />
        );
    }

    return (
        <Stack spacing="xl">
            <Title order={4}>{I18n.get('Sign-in Options')}</Title>
            <RecordForm
                record={selectedSigninOption}
                handleSubmit={saveRecord}
            />
        </Stack>
    );
};
